import { makeStyles } from '@fluentui/react-components';
import { uiblockerStyle } from '@bingads-webui-campaign-react/common-styles';

export const useCampaignNameTagStyles = makeStyles({
  button: {
    textAlign: 'left',
  },
});

export const useFilterDropdownStyles = makeStyles({
  root: {
    maxWidth: '250px',
  },
  truncatedText: {
    overflowX: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
});

export const useKeywordInputStyles = makeStyles({
  textarea: {
    width: '100%',
    height: '120px',
  },
  textareaContainer: {
    paddingLeft: '36px',
    width: '100%',
  },
});

export const useMeasurementTypeSelectorStyles = makeStyles({
  dropdownContainer: {
    paddingLeft: '36px',
    width: '100%',
  },
  dropdown: {
    width: '100%',
  },
  truncatedText: {
    overflowX: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
});

export const useRadioChildControlStyles = makeStyles({
  container: {
    paddingLeft: '36px',
    width: '100%',
  },
  warning: {
    marginTop: '10px',
  },
});

export const useSearchCustomerIdStyles = makeStyles({
  input: {
    width: '100%',
  },
});

export const useSelectCampaignGridStyles = makeStyles({
  dataGridRow: {
    opacity: '1',
  },
  dataGridRowDisabled: {
    opacity: '0.5',
  },
  selectCampaignTableCell: {
    alignItems: 'center',
    display: 'flex',
  },
  spinner: {
    'min-height': '50px',
  },
});

export const useTagsListStyles = makeStyles({
  root: {
    paddingBottom: '10px',
  },
  tagsList: {
    columnGap: '2px',
    display: 'flex',
    flexWrap: 'wrap',
    rowGap: '2px',
  },
  tagsToolbar: {
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'space-between',
  },
});

export const getUIBlockerStyle = () => ({
  '@global': uiblockerStyle({ palette: {} }),
});

export const noDataStyles = palette => ({
  color: palette.neutralSecondary,
  fontSize: '26px',
  paddingLeft: '32px',
});
